/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC } from "react";
import styles from "./SubscriptionToggleSwitch.module.css";

interface SubscriptionToggleSwitchProps {
    isAnnual: boolean;
    onToggle: (value: boolean) => void;
}

const SubscriptionToggleSwitch: FC<SubscriptionToggleSwitchProps> = ({
    isAnnual,
    onToggle,
}) => {
    const handleChange = () => {
        onToggle(!isAnnual);
    };

    return (
        <div className={styles.toggleSwitch}>
            <div className={styles.switchLabelWrapper}>
                <span
                    className={`${styles.switchLabel} ${
                        !isAnnual ? styles.selected : ""
                    }`}
                >
                    Monthly
                </span>
            </div>
            <label className={styles.switch}>
                <input
                    type="checkbox"
                    className={styles.hiddenInput}
                    checked={isAnnual}
                    onChange={handleChange}
                />
                <span className={styles.slider} />
            </label>
            <div className={styles.switchLabelWrapper}>
                <span
                    className={`${styles.switchLabel} ${
                        isAnnual ? styles.selected : ""
                    }`}
                >
                    Annual
                </span>
            </div>
        </div>
    );
};

export default SubscriptionToggleSwitch;
